define('bindingHandlers/webComponent',['lib/knockout',], function (ko) {
    'use strict';

/**
 * A binding handler that checks if the specified event occurs within the specified container. If not, it calls with given function with the given parameters.
 *
 * # Required Arguments
 *
 * @param init: MethodToBeCalledOnComponentLoad()
 * @param props - Values that should be mapped to properties of the component
 * @param methods - Methods that should be called on the component when any of the arguments change
 * @param events - Handlers for events emitted by the component
 * # Example
 *
 *      <div data-bind="
 *          configWebComponent: {
 *              props: {
 *                  'text': componentText
 *              },
 *              methods: {
 *                  'start': [arg1, arg2]
 *              }
 *              events: {
 *                  'click': clickHandler
 *              }
 *              initMethod: componentSetup
 *          }
 *      ">
 *
 */

    ko.bindingHandlers.webComponent = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
            var configParams = ko.unwrap(valueAccessor());
            if (configParams.events) {
                ko.bindingHandlers.event.init(element, ko.observable(configParams.events), allBindings, viewModel, bindingContext);
            }
            if (configParams.initMethod) {
                configParams.initMethod(element);
            }
        },
        update: function(element, valueAccessor) {
            var configParams = ko.toJS(valueAccessor());
            if (configParams.props) {
                Object.keys(configParams.props).forEach(function(key) {
                    element[key] = configParams.props[key];
                });
            }
            if (configParams.methods) {
                Object.keys(configParams.methods).forEach(function(key) {
                    var methodArgs = Array.isArray(configParams.methods[key]) ? configParams.methods[key] : [configParams.methods[key]];
                    element[key].apply(element, methodArgs);
                });
            }
        }
    };
    return ko.bindingHandlers.configWebComponent;
});
